const dashboardTourSteps = [
  {
    element: '#dashboard',
    intro: `Overview of all your recent crypto transactions/settlements. Track orders and payments.`
  },
  {
    element: '#wallets',
    intro: `Receive payments in Crypto with over 5+ supported cryptocurrencies.`
  },
  {
    element: '#payment-links',
    intro: `Create & Share payment links to receive payments in any amount, anywhere in the world.`
  },
  {
    element: '#transactions',
    intro: `Overview of all your transactions, status, payments and revenue.`
  },
  {
    element: '#transactions',
    intro: `Overview of all your transactions, status, payments and revenue.`
  },
  {
    element: '#settlement',
    intro: `Set your exchange preference and request settlement in any supported currency of your choice.`
  },
  {
    element: '#test_live_switch',
    intro: `Switch between test mode to test with our sandbox OR live mode; when you are ready to start accepting live payments. It's that easy.`
  }
  // ...
];

export { dashboardTourSteps };
